<div id="create-new-proposal" class="new-proposal revealed">
	<div class="new-proposal__content">
		<div class="new-proposal__form">
			<div class="new-proposal__fields new-proposal__fields--overview">
				<h3 i18n="@@proposals.proposal_overview">Proposal Overview</h3>
				<div class="new-proposal__fields--overview--TitleWrap"><span>{{ proposal.title }}</span></div>
				<div class="new-proposal__fields--overview--headerInfo">
					<div class="proposal-info">
						<span>
							<ng-container i18n="@@proposal">Proposal </ng-container>
							<strong>#{{ proposal.proposal_number }}</strong>
						</span>
						<span>
							<ng-container i18n="@@proposals.proposal_to">Proposal to </ng-container>
							<strong> : {{ proposal.client_name }}</strong>
						</span>
					</div>
					<div class="proposal-date" *ngIf="proposal.quote_date">
						<ng-container i18n="@@proposals.proposal_date">Proposal Date</ng-container>
						<strong> : {{ proposal.quote_date | date:'dd-MM-yyyy'}}</strong>
					</div>
				</div>

				<ul class="nav nav-tabs new-proposal__fields--overview--tabNav" id="myTab" role="tablist">
					<li class="nav-item">
						<a [class.active]="activeTab == 'project-detail'" (click)="switchTab('project-detail')" class="nav-link"
							id="project-details-tab" role="tab" aria-controls="project-details" aria-selected="true"
							i18n="@@proposals.project_details">Project Details</a>
					</li>
					<li class="nav-item">
						<a [class.active]="activeTab == 'quote'" (click)="switchTab('quote')" class="nav-link" id="quote-tab"
							role="tab" aria-controls="quote" aria-selected="false" i18n="@@proposals.quote">Quote</a>
					</li>
					<li class="nav-item">
						<a [class.active]="activeTab == 'terms'" (click)="switchTab('terms')" class="nav-link"
							id="termscondition-tab" data-toggle="tab" role="tab" aria-controls="termscondition" aria-selected="false"
							i18n="@@proposals.terms_and_condition">Terms & Condition</a>
					</li>
				</ul>

				<div class="tab-content" id="proposalOverview">

					<div class="tab-pane fade {{activeTab == 'project-detail' ? 'active show' : '' }}" id="project-details"
						role="tabpanel" aria-labelledby="project-details-tab">
						<div class="new-proposal__fields__wrap">
							<div
								class="new-proposal__fields__wrap--content"
								data-simplebar [ngClass]="">
								<div class="new-proposal__fields__wrap--content--inner">
									<p><strong i18n="@@proposals.project_description">Project Description</strong></p>
									<p class="pre-text">{{ proposal.description }}</p>

									<ng-container *ngIf="proposal.comments">
										<p><strong i18n="@@proposals.comments">Comments</strong></p>
										<p class="pre-text">{{ proposal.comments }}</p>
									</ng-container>
								</div>
							</div>
							<div class="new-proposal__fields__wrap--side">

								<div class="new-proposal__fields--project-details__sidebar--contentInner">
				          <label i18n="@@proposals.reference_files">Reference files</label>
				        </div>
					        
								<ng-container *ngIf="proposal.attachments && proposal.attachments.length; else noFiles">
									<div *ngFor="let attachment of proposal.attachments"  class="new-proposal__fields--project-details__sidebar--contentInner link-container">
					          <a *ngIf="attachment.path" [attr.href]="attachment.path" target="_blank" download>{{ attachment.name }}</a>
					          <a *ngIf="!attachment.path" href="javascript:void(0)">{{ attachment.name }}</a>
					        </div>
					      </ng-container>

					      <ng-template #noFiles>
					      	<div class="new-proposal__fields--project-details__sidebar--contentInner link-container text-center">
									    <p class="text-center w-100 mb-0">No Files</p>
									</div>
					      </ng-template>

								<ng-container *ngIf="proposal.links && proposal.links.length">
									<div class="new-proposal__fields--project-details__sidebar--contentInner">
										<label i18n="@@proposals.links_to_inspiration">Links to Inspiration</label>
									</div>

									<div *ngFor="let link of proposal.links"
										class="new-proposal__fields--project-details__sidebar--contentInner link-container">
										<a [attr.href]="link" target="_blank">{{ link }}</a>
									</div>
								</ng-container>
							</div>
						</div>

					</div>
					<!-- End project details tab -->

					<div class="tab-pane fade {{activeTab == 'quote' ? 'active show' : '' }}" id="quote" role="tabpanel"
						aria-labelledby="quote-tab">
						<div *ngIf="proposal.deliverables && proposal.deliverables.length; else noQuote" class="new-proposal__fields__wrap">
							<div class="new-proposal__fields__wrap--content new-proposal__fields__wrap--content--quote">
								<div class="quote-detail">
									<header class="quote-detail__header">
										<span class="quote-detail__header--title" i18n="@@proposals.deliverables">Deliverables</span>
										<span class="quote-detail__header--qty">
											<ng-container i18n="@@common.hrs" *ngIf="proposal.project_type == 'hourly';else qtyLabel">Hrs </ng-container>
											<ng-template i18n="@@common.qty" #qtyLabel>Qty</ng-template>
										</span>
										<span class="quote-detail__header--rate" i18n="@@proposals.rate">Rate</span>
										<span class="quote-detail__header--cost" i18n="@@proposals.cost">Cost</span>
									</header>
									<div class="quote-detail__content">
										<ul>
											<li *ngFor="let deliverable of proposal.deliverables; index as i">
												<span class="quote-detail__content--title"><span
														class="number">{{ i+1 }}</span>{{ deliverable.title }}</span>
												<span class="quote-detail__content--qty">{{ deliverable.quantity }}</span>
												<span class="quote-detail__content--rate">{{ deliverable.rate | myCurrency  }}</span>
												<span
													class="quote-detail__content--cost">{{ deliverableCost(deliverable) | myCurrency  }}</span>
											</li>
										</ul>
										<div class="quote-detail__content--total" [ngClass]="{'w-455': proposal.tax_rate || proposal.total_amount > 999}">
											<div class="quote-detail__content--total-item">
												<ng-container i18n="@@proposals.total_amount">Total Amount</ng-container>
												<br *ngIf="proposal.tax_rate"><span>{{ proposal.total_amount | myCurrency  }}</span>
											</div>
											<div class="quote-detail__content--total-item" *ngIf="proposal.tax_rate">
												<ng-container i18n="@@proposals.tax">VAT</ng-container>
												({{proposal.tax_rate}}%)<br><span>{{ (proposal.total_amount * proposal.tax_rate/100) | myCurrency  }}</span>
											</div>
											<div class="quote-detail__content--total-item">
												<ng-container i18n="@@proposals.sub_total">Sub Total</ng-container>
												<br *ngIf="proposal.tax_rate"><span>{{ proposal.sub_total ? (proposal.sub_total | myCurrency ) : '0.00' }}</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="new-proposal__fields__wrap--side new-proposal__fields__wrap--side--quote">
								<div class="new-proposal__fields__wrap--side--quote--title" i18n="@@proposals.invoice_terms">Invoice Terms</div>
								<div class="new-proposal__fields__wrap--side--quote--content">
									<ng-container *ngIf="proposal.payment_info && proposal.payment_info.name; else noPaymentInfo">
										<span i18n="@@payment_info.payment_made_to">Payment to be made to</span>
										<span i18n="@@payment_info.name">Name:</span>
										<span><strong>{{ proposal.payment_info.name }}</strong></span>
										<span i18n="@@payment_info.iban">IBAN:</span>
										<span><strong>{{ proposal.payment_info.iban }}</strong></span>
										<span i18n="@@payment_info.account_number">Account number:</span>
										<span><strong>{{ proposal.payment_info.account_number }}</strong></span>
										<span i18n="@@payment_info.bank_name">Bank Name:</span>
										<span><strong>{{ proposal.payment_info.bank_name }}</strong></span>
										<span i18n="@@payment_info.country">Country:</span>
										<span><strong>{{ proposal.payment_info.country }}</strong></span>
									</ng-container>

									<ng-template #noPaymentInfo>
										<span>Payment information is not added.</span>
									</ng-template>
								</div>
							</div>
						</div>

						<ng-template #noQuote>
							<div class="new-proposal__fields__wrap justify-content-center p-5">
								<span i18n="@@proposals.you_skipped_message">This section has been skipped by you.</span>
							</div>
						</ng-template>
					</div>
					<!-- End quote tab -->

					<div class="tab-pane fade {{activeTab == 'terms' ? 'active show' : '' }}" id="termscondition" role="tabpanel"
						aria-labelledby="termscondition-tab">
						<div *ngIf="terms; else noTerms" class="new-proposal__fields__wrap">
							<div class="new-proposal__fields__wrap--content new-proposal__fields__wrap--content--termsCondition"
								data-simplebar>
								<div class="new-proposal__fields__wrap--content--inner">
									<div *ngFor="let termGroup of getObjectValues(terms)"
										class="new-proposal__fields__wrap--content--inner--section">
										<p><strong>{{termGroup.title}}</strong></p>
										<p class="pre-text" *ngFor="let term of getObjectValues(termGroup.terms)">{{term.description}}</p>
									</div>
								</div>
							</div>
						</div>

						<ng-template #noTerms>
							<div class="new-proposal__fields__wrap justify-content-center p-5">
								<span i18n="@@proposals.you_skipped_message">This section has been skipped by you.</span>
							</div>
						</ng-template>
					</div>
					<!-- End terms tab -->
				</div>

				<div class="new-proposal__controlsBTN fullTwoColumn">
					<div>
						<a (click)="back.emit()" href="javascript:void(0)" class="tu-btn transparent" i18n="@@button.back">Back</a>
						<a (click)="onEdit.emit(proposal)" href="javascript:void(0)" class="tu-btn transparent"
							i18n="@@button.edit">Edit</a>
					</div>
				</div>

			</div>
		</div>
	</div>
</div>